import Image from 'next/image';
import React from 'react';

const ArchitectureDiagramVisionMultimodalAi = () => {
    return (
        <div className="section-py dark:bg-black !pb-[60px]">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="md:col-span-12 text-center">
                        <div className='flex flex-col items-center gap-2.5'>
                        <h2 className="text-primary" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Vision AI and Multimodal Pipeline
                        </h2>
                        <Image
                            src="/img/vision-and-multimodal-ai/svg/diagram-visionai.svg"
                            width={1236}
                            height={800}
                            className="img-fluid lg:block md:hidden hidden"
                            alt="Architecture Diagram"
                            loading="lazy"
                        />
                        <Image
                            src="/img/vision-and-multimodal-ai/svg/diagram-visionai-mobile.svg"
                            width={1236}
                            height={800}
                            className="img-fluid lg:hidden md:block block"
                            alt="Architecture Diagram"
                            loading="lazy"
                        />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArchitectureDiagramVisionMultimodalAi;
